import React from 'react';
import './Loading.scss';

const Loading=({text = 'loading'})=>
    <div className="loader">
        <div className="loader-spinner"/>
    </div>;

export default Loading;